import logo from "./logo.svg";
import "./App.css";
import Home from "./Home/Home";
import 'bootstrap/dist/css/bootstrap.css';
function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
